module.exports = __webpack_public_path__ + "img/Advanced from committee.a8e2c177.svg";